import classNames from "classnames";
import { FC } from "react";
import { CasinoScopesMap, useCasinoGames } from "@finbackoffice/site-core";
import Loading from "components/base/loading/Loading";
import Translate from "components/base/translate/Translate";
import { CasinoGameItem } from "../../game-item/CasinoGameItem";
import { ICasinoSearchBlockContext } from "../CasinoSearchBlock";
import styles from "./search-results.module.sass";

const SearchResults: FC<ICasinoSearchBlockContext & { searchValue: string }> = ({
    searchValue,
    gameTypes,
}) => {
    const { casinoGamesState } = useCasinoGames(gameTypes, "", "All", { gameName: searchValue });
    const isSlots = gameTypes === CasinoScopesMap.slots;

    return (
        <div
            className={classNames(
                styles.casinoSearchResult,
                styles[`sr-search-${isSlots ? "slots" : "livecasino"}`],
            )}>
            {casinoGamesState.loading && <Loading />}
            {!casinoGamesState.loading && !casinoGamesState.totalCount && (
                <div className="no-game">
                    <Translate tid="no_games" />
                </div>
            )}
            {casinoGamesState.games.map((game) => (
                <CasinoGameItem key={game.id} game={game} showName hidePlayButtons={!isSlots} />
            ))}
        </div>
    );
};

export default SearchResults;
